import React from 'react'

export default function ReflexiveModal() {
  return (
    <div className='column-table-reflexive'>
        <p className='bold'>Reflexive</p>
        <p>me</p>
        <p>te</p>
        <p>se</p>
        <p>nos</p>
        <p>os</p>
        <p>se</p>
    </div>
  )
}
